export enum ThreePLTrainServiceStatusType {
  Approved = 'Approved',
  Declined = 'Declined',
  Submitted = 'Submitted',
  Canceled = 'Canceled'
}
